import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer text-white pt-5 pb-4">
      <Container>
        <Row className="gy-4">
          {/* Company Overview */}
          <Col md={4}>
            <h5 className="footer-title">Intelisparkz Systems</h5>
            <div className="footer-underline"></div>
            <p className="small text-light mt-3">
              Intelisparkz delivers cutting-edge digital solutions for industry,
              defense, and enterprises. We empower innovation through scalable,
              secure, AI-driven platforms.
            </p>
            {/* TODO: verify these social handles exist before launch */}
            <div className="d-flex gap-3 mt-4">
              <a
                href="https://facebook.com/intelisparkz"
                target="_blank"
                rel="noreferrer"
                className="footer-social"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://twitter.com/intelisparkz"
                target="_blank"
                rel="noreferrer"
                className="footer-social"
              >
                <FaTwitter />
              </a>
              <a
                href="https://instagram.com/intelisparkz"
                target="_blank"
                rel="noreferrer"
                className="footer-social"
              >
                <FaInstagram/>
              </a>
            </div>
          </Col>

          {/* Links */}
          <Col md={4}>
            <h6 className="footer-title">Quick Links</h6>
            <div className="footer-underline"></div>
            <ul className="list-unstyled small mt-3">
              <li>
                <Link to="/" className="footer-link">
                  → Home
                </Link>
              </li>
              <li>
                <Link to="about" className="footer-link">
                  → About
                </Link>
              </li>
              <li>
                <Link to="/career" className="footer-link">
                  → Career
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  → Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="footer-link">
                  → Privacy Policy
                </Link>
              </li>
            </ul>
          </Col>

          {/* Contact */}
          <Col md={4}>
            <h6 className="footer-title">Contact</h6>
            <div className="footer-underline"></div>
            <ul className="list-unstyled small mt-3 text-light">
              <li>📍 K8 Kalinga Nagar,Shampur <br></br>
                Bhubaneswar, Odisha 751003 India</li>
              <li>📞 +91 9583393333</li>
              <li>✉️ contact@intelisparkz.com</li>
            </ul>
          </Col>
        </Row>
      </Container>
      <hr className="mt-4 border-light opacity-25" />
      <div className="text-center small text-light mt-2">
        © {new Date().getFullYear()} Intelisparkz Systems. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
